import React, { Component } from "react";
import { List } from "bootstrap-4-react";
import Navmenu from "../components/Navmenu";
import Appbar from "../components/Appbar";
import "../style/WebinarSchedule.scss";
import { Row, Col } from "bootstrap-4-react";
import Footer from "../components/Footer";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { apiURL, isLogin } from "../utils";
import axios from "axios";
import Moment from "moment";
import SanitizedHTML from "react-sanitized-html";
import Sign from "../login/Sign";
import imgIcon from "../images/Navdisha-Logo-PNG.f407ae7ec6557a4db693.png";
import {
  Container,
  DialogContent,
  Dialog,
  IconButton,
  Snackbar,
} from "@material-ui/core";
import WebinarForm from "../webinar/WebinarForm";
import Alert from "@material-ui/lab/Alert";
import dateImage from "../images/date.png";
import timeImage from "../images/time.png";
import durationImage from "../images/duration.png";
import Video_dialog from "../Video_dialog";
import Meta from "../meta/Meta";
import Rating from "../components/Rating";
import ReactPlayer from "react-player/lazy";
import { Bookmark, BookmarkBorder, LocationOn } from "@material-ui/icons";
import { getID } from "../utils";
import ShareDialog from "../components/ShareDialog";
import ShareNews from "../govt-circular-gr/ShareNews";
import OtherWebinar from "./OtherWebinar";
import NoDataFound from "../common/NoDataFound";

const styles = () => ({
  root: { maxWidth: "100%" },
});

class Webinar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventData: {},
      points: [],
      is_bookmark: false,
      showComponent: false,
      dialogOpen: false,
      video_url: "",
      showShareDialog: false,
      showSnackbar: false,
      snackBarMessage: "",
      severityColor: "success",
      snackBarTimer: 3000,
      noResult: false, //  KEY FLAG
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getPastWebinar();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.webinarId !== this.props.match.params.webinarId
    ) {
      this.getPastWebinar();
    }
  }

  getPastWebinar = () => {
    const body = {
      webinar_id: this.props.match.params.webinarId,
      user_id: getID(),
    };

    axios
      .post(apiURL("webinar/get_webinar_by_id"), body)
      .then((res) => {
        if (res.data.status === true || res.data.status === 1) {
          const eventData = res.data.result;
          this.setState({
            eventData,
            points: JSON.parse(eventData.fldt_points || "[]"),
            is_bookmark: eventData.is_bookmark,
            noResult: false,
          });
        } else {
          this.setState({ noResult: true });
        }
      })
      .catch(() => this.setState({ noResult: true }));
  };

  handleBack = () => {
    this.props.history.push("/past-webinars");
  };

  handleAddBookMark = (id) => {
    axios
      .post(apiURL("bookmark/addBookmark"), {
        content_id: id,
        content_type: "past_webinar",
        user_id: getID(),
      })
      .then(() => this.setState({ is_bookmark: true }));
  };

  handleRemoveBookMark = (id) => {
    axios
      .post(apiURL("bookmark/removeBookmark"), {
        content_id: id,
        content_type: "past_webinar",
        user_id: getID(),
      })
      .then(() => this.setState({ is_bookmark: false }));
  };

  render() {
    const { classes } = this.props;
    const { eventData, noResult } = this.state;
    const link = eventData?.fldv_video_link?.trim();

    return (
      <>
        <Meta
          tableName="webinar"
          objectId={this.props.match.params.webinarId}
          forPage="inner_page"
        />

        <Appbar />
        <div className="sticky-top sign-light">
          <Navmenu />
        </div>
        {noResult && (
          <section className="pastweb">
            <Container maxWidth="lg" className="text-center">
              <NoDataFound message="This past webinar is no longer available." />
            </Container>
          </section>
        )}
        {!noResult && (
          <>
            <section className="pastweb">
              <Container maxWidth="lg">
                <h1>{eventData.fldv_title}</h1>

                <Row>
                  <Col lg="6">
                    <h5>{eventData.fldv_speaker_name}</h5>
                    {this.state.points.map((p, i) => (
                      <p key={i}>{p.point}</p>
                    ))}
                    <SanitizedHTML html={eventData.fldv_description} />
                  </Col>

                  <Col lg="6">
                    {!link ? (
                      <img
                        src={imgIcon}
                        alt="default"
                        style={{ width: "100%" }}
                      />
                    ) : /^(https?:\/\/)/i.test(link) ? (
                      <ReactPlayer url={link} controls width="100%" />
                    ) : (
                      <div>
                        <img
                        src={imgIcon}
                        alt="default"
                        style={{ width: "100%" }}
                      /></div>
                    )}

                  </Col>
                </Row>

                <table className="table mt-4">
                  <tbody>
                    <tr>
                      <td>
                        <img src={dateImage} alt="" />{" "}
                        {Moment(eventData.fldv_select_date).format(
                          "DD MMM YYYY",
                        )}
                      </td>
                      <td>
                        <img src={timeImage} alt="" />{" "}
                        {Moment(eventData.fldt_time).format("hh:mm A")}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <img src={durationImage} alt="" />{" "}
                        {eventData.fldv_duration} Hours
                      </td>
                      <td>
                        <LocationOn /> {eventData.fldv_venue_location}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Container>
            </section>

            <section className="buttonPastWebContainer">
              <Container maxWidth="lg">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <IconButton
                    style={{
                      border: "3px solid #064e89",
                      color: this.state.is_bookmark ? "orange" : "#064e89",
                    }}
                    onClick={() =>
                      this.state.is_bookmark
                        ? this.handleRemoveBookMark(eventData.fldi_id)
                        : this.handleAddBookMark(eventData.fldi_id)
                    }
                  >
                    {this.state.is_bookmark ? <Bookmark /> : <BookmarkBorder />}
                  </IconButton>
                  <div className="rating">
                    <Rating
                      webinarId={eventData.fldi_id}
                      userId={getID()}
                      rating={eventData.rating}
                      color="gold"
                    />
                  </div>
                </div>

                <ShareNews
                  webinarId={eventData.fldi_id}
                  shareUrl={window.location.href}
                  title={eventData.fldv_title}
                  date={Moment(eventData.fldv_select_date).format(
                    "DD MMM YYYY",
                  )}
                  time={Moment(eventData.fldt_time).format("hh:mm A")}
                />

                <div className="articleBack">
                  <Button onClick={this.handleBack}>Back</Button>
                </div>
              </Container>
            </section>
          </>
        )}
        <OtherWebinar
          id={this.props.match.params.webinarId}
          history={this.props.history}
        />

        <Footer />
      </>
    );
  }
}

export default withStyles(styles)(Webinar);
